import { Tweet } from "@/types";

export const featuredTweets: Tweet[] = [
  {
    id: "1",
    username: "Ansem",
    handle: "blknoiz06",
    profileImage: "ansem.jpg",
    text: "black bull mode",
    time: "7:03 PM · JUL 5, 2026",
    image: "ansem-post.jpg",
    link: "https://x.com/blknoiz06/status/2073905527046742308?s=20",
    comments: 984,
    retweets: 478,
    likes: 2900,
    views: 175000,
  },
  {
    id: "2",
    username: "",
    handle: "trading_axe",
    profileImage: "trading-axe.jpg",
    text: "Second best trader I know told me that crypto is close to a bottom, if not already there. \n\nSaylor \"FUD\" is largely exaggerated [which I disagree with, but time will tell].\n\nBTC quantum hack \"FUD\" is also irrelevant, banks are at much bigger risks etc.\n\nThe only true \"downside\" from here is Dems winning midterm elections, which is massively overlooked atm.\n\nDems gaining control of the legislature [which holds the power to enact law] is clearly not the best thing for crypto given how much scamming Trump + co have done.\n\nBut all in all,\n\nYou should be AT LEAST buying Bitcoin as a serious player of this very unserious industry.\n\nH O P I U M.\n\n~ Dr. Axius.",
    time: "3:30 PM · JUL 4, 2026",
    link: "https://x.com/trading_axe/status/2073489601910722798?s=20",
    comments: 39,
    retweets: 22,
    likes: 457,
    views: 37300,
  },
  {
    id: "3",
    username: "DonAlt",
    handle: "DonAlt",
    profileImage: "donalt.jpg",
    text: "BTC staying sideways as Saylor authorizes Bitcoin sales\n\nTells you all you need to know about how retarded their strategy has been, them selling is starting to turn into good news not bad news\n\nNo one wants to deal with their retardation anymore and wants them smaller not bigger",
    time: "6:16 PM · JUN 29, 2026",
    link: "https://x.com/DonAlt/status/2071719435841523721?s=20",
    comments: 101,
    retweets: 114,
    likes: 2100,
    views: 151400,
  },
  {
    id: "4",
    username: "@levelsio",
    handle: "levelsio",
    profileImage: "levelsio.jpg",
    text: "Bitcoin has always been operating in 4 year cycles where it crashes at the end\n\n2014, 2018, 2022, 2026\n\nIt's actually great because every 4th year people really get super sad and give up on it (or well that's how it feels like)\n\nThere's also surely some sentiment pumping to push the price down so people can buy in cheap again\n\nThe next cycle up is 2027-2031\n\n(And it has something to with the halvening which happens every 4 years cutting the reward for miners in half)",
    time: "9:16 PM · JUN 24, 2026",
    image: "levelsio-post.jpg",
    link: "https://x.com/levelsio/status/2069952884548993073?s=20",
    comments: 64,
    retweets: 200,
    likes: 2500,
    views: 1400000,
  },
];
